import { useSearchParams } from "react-router-dom";

export const useQueryParams = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const currentDate = searchParams.get("currentDate");
  const pageType = searchParams.get("pageType") || k_pageType.zc;
  const all = searchParams.get("all");
  return { currentDate, email, pageType, all };
};

export const k_pageType = {
  sz: "sz", // 设总
  zc: "zc"  // 专负
}
const k_typeLabel: Record<string, string> = {
  sz: "设总",
  zc: "专负"
}
export const getPageTypeLabel = (pageType: string) => {
  return k_typeLabel[pageType] || "专负"
}

export default useQueryParams;